export default "__VITE_ASSET__D8O24ktl__"